import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function TestimonialsSection() {
  const fadeIn = useFadeIn();
  const testimonials = [{
    quote: 'Llevaba 2 años sin poder tener una conversación real con mi hijo. Con el Tomo 2 entendí por qué explotaba. Con el Tomo 5 aprendí a acercarme diferente. Hoy hablamos.',
    author: 'Marcela R. — Buenos Aires · Madre de adolescente de 16 años',
    stars: 5
  }, {
    quote: 'Lo integré en mis sesiones de tutoría y el cambio en los estudiantes fue visible en semanas. Tienen vocabulario emocional que antes no tenían.',
    author: 'Rodrigo T. — Córdoba · Docente de Secundaria',
    stars: 5
  }, {
    quote: 'Como terapeuta buscaba recursos estructurados para adolescentes. Este sistema es exactamente lo que mis pacientes necesitaban para trabajar entre sesiones.',
    author: 'Dra. Carmen V. — Santiago de Chile · Psicóloga Clínica',
    stars: 5
  }, {
    quote: 'Mi hija de 15 completó el Tomo 1 sola en una semana. Después me pidió que lo hiciéramos juntas desde el principio. Lloramos juntas en varios ejercicios. Vale cada peso.',
    author: 'Sofía C. — Santiago · Mamá de dos adolescentes',
    stars: 5
  }];
  return <section className="py-10 md:py-16 px-4 bg-white" data-id="element-395">
      <div className="max-w-3xl mx-auto" data-id="element-396">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-397">
          <div className="text-center mb-8 md:mb-12" data-id="element-398">
            <h2 className="text-2xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-399">
              💬 Lo que Dicen Quienes Ya Empezaron su Transformación
            </h2>
            <div className="w-24 h-2 bg-yellow-400 mx-auto rounded-full" data-id="element-400"></div>
          </div>

          <div className="space-y-4 md:space-y-6" data-id="element-401">
            {testimonials.map((t, idx) => <div key={idx} className="bg-gray-50 p-5 md:p-8 rounded-2xl border border-gray-200 shadow-sm relative" data-id="element-402">
                <div className="absolute top-4 right-6 text-4xl text-gray-200 font-serif" data-id="element-403">
                  "
                </div>
                <div className="flex text-yellow-400 mb-3" data-id="element-404">
                  {[...Array(t.stars)].map((_, i) => <svg key={i} className="w-6 h-6 fill-current" viewBox="0 0 20 20" data-id="element-405">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-406" />
                    </svg>)}
                </div>
                <p className="text-base md:text-2xl font-bold text-gray-800 mb-4 italic leading-relaxed relative z-10" data-id="element-407">
                  "{t.quote}"
                </p>
                <p className="text-gray-600 font-bold uppercase tracking-wide text-xs md:text-sm" data-id="element-408">
                  {t.author}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}